import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with 23:59:35 in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 35);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 md:space-x-4 text-miel-gold font-playfair text-3xl md:text-5xl font-bold" data-id="element-33">
      <div className="flex flex-col items-center" data-id="element-34">
        <div className="bg-miel-darker border border-miel-gold/30 rounded-lg px-3 py-2 md:px-4 md:py-3 shadow-inner" data-id="element-35">
          {formatTime(hours)}
        </div>
        <span className="text-xs font-inter text-miel-cream/60 mt-1 uppercase tracking-wider" data-id="element-36">
          hs
        </span>
      </div>
      <span className="text-miel-gold/50 pb-5" data-id="element-37">:</span>
      <div className="flex flex-col items-center" data-id="element-38">
        <div className="bg-miel-darker border border-miel-gold/30 rounded-lg px-3 py-2 md:px-4 md:py-3 shadow-inner" data-id="element-39">
          {formatTime(minutes)}
        </div>
        <span className="text-xs font-inter text-miel-cream/60 mt-1 uppercase tracking-wider" data-id="element-40">
          min
        </span>
      </div>
      <span className="text-miel-gold/50 pb-5" data-id="element-41">:</span>
      <div className="flex flex-col items-center" data-id="element-42">
        <div className="bg-miel-darker border border-miel-gold/30 rounded-lg px-3 py-2 md:px-4 md:py-3 shadow-inner" data-id="element-43">
          {formatTime(seconds)}
        </div>
        <span className="text-xs font-inter text-miel-cream/60 mt-1 uppercase tracking-wider" data-id="element-44">
          seg
        </span>
      </div>
    </div>;
}